module.exports = __webpack_public_path__ + "img/2024-11.ce50770e.jpg";